export const routes = {
         home: "/",
         castles: "/castles",
         castle: "/castles/:id",
         forgotens: "/forgotens",
         forgoten: "/forgotens/:id",
       };
